export default {
    containableByStructure: false
}
